import { formatFormFieldReport } from '../ProblemsReporter.js';

export const execute = (node, context) => {

  const {
    executionPlatformLabel,
    reporter,
    category
  } = context;

  if (node.components) {

    const hasLayout = _hasComponentsSharingRow(node) || _hasComponentsOfDefinedWidth(node);

    if (hasLayout) {
      const errorMessage = `Row and column layouts are not supported by ${executionPlatformLabel}`;
      reporter.report(formatFormFieldReport(node, errorMessage, category));
    }
  }

  return true;
};

const _hasComponentsSharingRow = (node) => {

  const rowSet = new Set();

  for (const component of node.components.filter(c => c.layout)) {

    const row = component.layout.row;
    if (rowSet.has(row)) {
      return true;
    }
    rowSet.add(row);
  }

  return false;
};

const _hasComponentsOfDefinedWidth = (node) => {

  return node.components.some(component => {
    return component.layout && component.layout.columns;
  });
};